import * as tslib_1 from 'tslib';
import * as i0 from '@angular/core';
import { Component, EventEmitter, Input, Output, NgModule, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/common/http';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import * as signalR from '@microsoft/signalr';

let SharedComponent = class SharedComponent {
};
SharedComponent = tslib_1.__decorate([
    Component({
        selector: 'shared-component',
        template: `
    <h4>
      Shared component
    </h4>
  `
    })
], SharedComponent);

class TaskResult {
}

let ApproveConfirmComponent = class ApproveConfirmComponent {
    constructor() {
        this.showApprove = false;
        this.showResult = false;
        this.showRetryButton = true;
        this.tries = 0;
        this.taskId = "0";
        this.maxTries = 3;
        this.approveButtonLabel = "Yes";
        this.cancelButtonLabel = "No";
        this.acceptButtonLabel = "Ok";
        this.retryButtonLabel = "Retry";
        this.taskApproved = new EventEmitter();
        this.taskCancelled = new EventEmitter();
        this.taskResultAccepted = new EventEmitter();
        this.taskRetry = new EventEmitter();
    }
    ngOnInit() {
        this.tries = 0;
        console.log("taskId = |" + this.taskId + "|"
            + " thingToDo = |" + this.taskToDo + "|"
            + " maxTries = |" + this.maxTries + "|"
            + " successMessage = |" + this.successMessage + "|"
            + " failureMessage = |" + this.failureMessage + "|"
            + " approveButtonLabel = |" + this.approveButtonLabel + "|"
            + " cancelButtonLabel = |" + this.cancelButtonLabel + "|"
            + " acceptButtonLabel = |" + this.acceptButtonLabel + "|"
            + " retryButtonLabel = |" + this.retryButtonLabel + "|");
    }
    hide() {
        this.showResult = false;
        this.showApprove = false;
    }
    showApproveDialog(changes) {
        this.tries = 0;
        this.success = false;
        this.changes = changes;
        this.showRetryButton = false;
        this.showResult = false;
        this.showApprove = true;
    }
    showTaskSucceeded() {
        this.tries = this.tries + 1;
        this.success = true;
        this.showRetryButton = false;
        this.showApprove = false;
        this.showResult = true;
    }
    showTaskFailed() {
        this.tries = this.tries + 1;
        this.success = false;
        if ((this.maxTries < 1) || (this.tries < this.maxTries)) {
            this.showRetryButton = true;
        }
        else {
            this.showRetryButton = false;
        }
        this.showApprove = false;
        this.showResult = true;
    }
    approveTask() {
        // The event data emitted here is the task identifier alone
        // No other data on success, etc. is necessary
        // The task id is provided to allow the receiver to distinguish between multiple 
        // approve-confirm instances they may have and act accordingly.
        this.taskApproved.emit(this.taskId);
    }
    cancelTask() {
        // The event data emitted here is the task identifier alone
        // No other data on success, etc. is necessary
        // The task id is provided to allow the receiver to distinguish between multiple 
        // approve-confirm instances they may have and act accordingly.
        this.taskCancelled.emit(this.taskId);
        this.hide();
        this.tries = 0;
    }
    acceptResult() {
        // The event data emitted here provides as full information as possible
        // on the tasks resolution to allow the receiver to operate mostly statelessly on it if it wants.
        // It is in the form of a TaskResult model.
        let taskResult = new TaskResult();
        taskResult.taskId = this.taskId;
        taskResult.success = this.success;
        taskResult.errorMessage = this.errorMessage;
        taskResult.tries = this.tries;
        this.taskResultAccepted.emit(taskResult);
        this.hide();
        this.tries = 0;
    }
    retryTask() {
        // The event data emitted here provides as full information as possible
        // on the tasks resolution to allow the receiver to operate mostly statelessly on it if it wants.
        // It is in the form of a TaskResult model.
        let taskResult = new TaskResult();
        taskResult.taskId = this.taskId;
        taskResult.success = this.success;
        taskResult.errorMessage = this.errorMessage;
        taskResult.tries = this.tries;
        this.taskRetry.emit(taskResult);
        this.tries = 0;
    }
    resetTries() {
        this.tries = 0;
    }
    setErrorMessage(message) {
        this.errorMessage = message;
    }
};
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", String)
], ApproveConfirmComponent.prototype, "taskId", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", String)
], ApproveConfirmComponent.prototype, "taskToDo", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", Number)
], ApproveConfirmComponent.prototype, "maxTries", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", String)
], ApproveConfirmComponent.prototype, "successMessage", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", String)
], ApproveConfirmComponent.prototype, "failureMessage", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", String)
], ApproveConfirmComponent.prototype, "approveButtonLabel", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", String)
], ApproveConfirmComponent.prototype, "cancelButtonLabel", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", String)
], ApproveConfirmComponent.prototype, "acceptButtonLabel", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", String)
], ApproveConfirmComponent.prototype, "retryButtonLabel", void 0);
tslib_1.__decorate([
    Input(),
    tslib_1.__metadata("design:type", String)
], ApproveConfirmComponent.prototype, "errorMessage", void 0);
tslib_1.__decorate([
    Output(),
    tslib_1.__metadata("design:type", Object)
], ApproveConfirmComponent.prototype, "taskApproved", void 0);
tslib_1.__decorate([
    Output(),
    tslib_1.__metadata("design:type", Object)
], ApproveConfirmComponent.prototype, "taskCancelled", void 0);
tslib_1.__decorate([
    Output(),
    tslib_1.__metadata("design:type", Object)
], ApproveConfirmComponent.prototype, "taskResultAccepted", void 0);
tslib_1.__decorate([
    Output(),
    tslib_1.__metadata("design:type", Object)
], ApproveConfirmComponent.prototype, "taskRetry", void 0);
ApproveConfirmComponent = tslib_1.__decorate([
    Component({
        selector: 'approve-confirm',
        template: "<div>\r\n    <div [hidden]=\"!(showApprove || showResult)\" class=\"fade-screen\">\r\n        &nbsp;\r\n    </div>\r\n    <div [hidden]=\"!(showApprove || showResult)\" class=\"approve-confirm-box\">\r\n\r\n<div>\r\n    <div [hidden]=\"!showApprove\">\r\n        <p>Are you sure you want to {{ taskToDo }}?</p>\r\n        <p *ngIf=\"(changes != undefined) && (changes.length != 0)\">\r\n            Summary of changes:\r\n        </p>\r\n        <ul *ngIf=\"(changes != undefined) && (changes.length != 0)\">\r\n            <li *ngFor=\"let change of changes\" class=\"approve-change-text\">\r\n                {{ change }}\r\n            </li>\r\n        </ul>\r\n        <div>\r\n            <button (click)=\"approveTask()\" class=\"approve-confirm-box-button btn-lg\">{{ approveButtonLabel }}</button>\r\n            <button (click)=\"cancelTask()\" class=\"approve-confirm-box-button btn-lg\">{{ cancelButtonLabel }}</button>\r\n        </div>\r\n    </div>\r\n\r\n    <div [hidden]=\"!showResult\">\r\n        <div [hidden]=\"!success\">{{ successMessage }}</div>\r\n        <div [hidden]=\"success\">{{ failureMessage }} {{ errorMessage }}</div>\r\n        <div>\r\n            <button (click)=\"acceptResult()\" class=\"approve-confirm-box-button btn-lg\">{{ acceptButtonLabel }}</button>\r\n            <button *ngIf=\"showRetryButton\" (click)=\"retryTask()\" class=\"approve-confirm-box-button btn-lg\">{{ retryButtonLabel }}</button>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n    </div>\r\n</div>\r\n"
    }),
    tslib_1.__metadata("design:paramtypes", [])
], ApproveConfirmComponent);

let LoadingComponent = class LoadingComponent {
    constructor() {
        this.showLoading = false;
    }
    ngOnInit() {
    }
    showSpinner() {
        this.showLoading = true;
    }
    hideSpinner() {
        this.showLoading = false;
    }
};
LoadingComponent = tslib_1.__decorate([
    Component({
        selector: 'loading-spinner',
        template: "<div>\r\n\t<div [hidden]=\"!showLoading\" class=\"fade-screen\">\r\n\t\t&nbsp;\r\n\t</div>\r\n\t<div [hidden]=\"!showLoading\" class=\"loading-spinner\">\r\n\t\t<i class=\"fa fa-spinner fa-5x fa-spin\"></i> <!-- alternatives: https://fontawesome.com/how-to-use/on-the-web/styling/animating-icons -->\r\n\t</div>\r\n</div>\r\n"
    }),
    tslib_1.__metadata("design:paramtypes", [])
], LoadingComponent);

const sharedComponents = [SharedComponent, ApproveConfirmComponent, LoadingComponent];
let SharedModule = class SharedModule {
};
SharedModule = tslib_1.__decorate([
    NgModule({
        imports: [CommonModule],
        declarations: [...sharedComponents],
        exports: [...sharedComponents]
    })
], SharedModule);

class Config {
}

let AppConfigService = class AppConfigService {
    constructor(http) {
        this.http = http;
        this.postHeaders = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        this.config = undefined;
        console.log("cmtApiUrl = " + JSON.stringify(environment.cmtApiUrl));
    }
    getConfig() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.config != undefined) {
                console.log("Returning cached app config: config = " + JSON.stringify(this.config));
                return this.config;
            }
            let cmtApiUrl = environment.cmtApiUrl;
            let configX = yield this.http.get(`${cmtApiUrl}/api/media/configuration`).toPromise();
            console.log("App config from api: config = " + JSON.stringify(configX));
            this.config = new Config();
            this.config.imageThumbnailWidthPixels = configX.imageThumbnailWidthPixels;
            this.config.mediaSetMaxTotalSizeKB = configX.mediaSetMaxTotalSizeKB;
            this.config.mediaMaxSizeKB = configX.mediaMaxSizeKB;
            this.config.validMediaFileExtensions = configX.validMediaFileExtensions;
            this.config.validMediaMimeTypes = configX.validMediaMimeTypes;
            this.config.fileExtensionToMimeTypeSourceMap = configX.fileExtensionToMimeTypeSourceMap;
            this.config.fileExtensionToMimeTypeTargetMap = configX.fileExtensionToMimeTypeTargetMap;
            console.log("Cached app config: config = " + JSON.stringify(this.config));
            return this.config;
        });
    }
    userHasPermission(permission) {
        try {
            let permissionGranted = window['keycloak_hasPermission'](permission);
            console.log('AppConfig - Checking permission: ' + permission + ' : Granted = ' + permissionGranted);
            return permissionGranted;
        }
        catch (err) {
            console.log('AppConfig - Failed to check permission: ' + permission + ' : error = ' + JSON.stringify(err));
            return false;
        }
    }
    checkPermissionInToken(permission) {
        let permissionGranted = false;
        let authToken = sessionStorage.getItem("keycloakToken");
        if (authToken != undefined && authToken.length > 0) {
            var tokenSplit = authToken.split('.');
            if (tokenSplit.length > 1) {
                let tokenPayloadBase64 = tokenSplit[1];
                var tokenPayload = JSON.parse(window.atob(tokenPayloadBase64));
                console.log('Token Payload = ' + JSON.stringify(tokenPayload));
                if (tokenPayload["resource_access"] != undefined) {
                    var resourceAccess = tokenPayload["resource_access"];
                    let resourceAccessJson = JSON.stringify(resourceAccess);
                    console.log('Token resourceAccess = ' + resourceAccessJson);
                    if (resourceAccessJson.indexOf(permission) >= 0) {
                        console.log('Permission ' + permission + ' is OK in token');
                        permissionGranted = true;
                    }
                }
                else {
                    console.log('Warning: no resource_access in token payload - check token is valid.  Token Payload = ' + JSON.stringify(tokenPayload));
                }
            }
            else {
                console.log("No payload found in token " + authToken);
            }
        }
        return permissionGranted;
    }
};
/** @nocollapse */ AppConfigService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppConfigService_Factory() { return new AppConfigService(i0.ɵɵinject(i1.HttpClient)); }, token: AppConfigService, providedIn: "root" });
AppConfigService = tslib_1.__decorate([
    Injectable({ providedIn: 'root' }),
    tslib_1.__metadata("design:paramtypes", [HttpClient])
], AppConfigService);

let PublishService = class PublishService {
    constructor() {
        this.publishUpdateEvent = new EventEmitter();
        console.log("Publish Service Instantiated");
    }
    init() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!environment.rulePluginEnabled) {
                return;
            }
            this.stopConnection();
            //Add access token bit
            this.hubConnection = new signalR.HubConnectionBuilder().withUrl(environment.hubUrl).configureLogging(signalR.LogLevel.Information).build();
            this.hubConnection.on("UpdateAvailability", (expiryTime = null) => {
                console.log("Publish end time: " + expiryTime);
                this.publishUpdateEvent.emit(expiryTime);
            });
            yield this.hubConnection.start().then(() => {
                console.log("Connection to publish hub started");
            }).catch(err => {
                console.log("Couldn't connect to publish hub " + err);
                setTimeout(() => this.init(), 5000);
            });
        });
    }
    stopConnection() {
        if (this.hubConnection) {
            this.hubConnection.stop();
            this.hubConnection = null;
        }
    }
    GetPublishEndTime() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.hubConnection.invoke('GetPublishEndTime')
                .then((expiryTime) => { return expiryTime; })
                .catch(err => { console.log(err); return null; });
        });
    }
    StartPublish() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.hubConnection.invoke('StartPublish')
                .then((success) => {
                console.log("This is success" + success);
                return success;
            })
                .catch(err => { console.log(err); return false; });
        });
    }
    EndPublish() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return yield this.hubConnection.invoke('EndPublish')
                .then((success) => { return success; })
                .catch(err => { console.log(err); return false; });
        });
    }
};
/** @nocollapse */ PublishService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PublishService_Factory() { return new PublishService(); }, token: PublishService, providedIn: "root" });
PublishService = tslib_1.__decorate([
    Injectable({ providedIn: 'root' }),
    tslib_1.__metadata("design:paramtypes", [])
], PublishService);

class ConfigMvc {
}

class ServiceResult {
}

/*
 * Public API Surface of shared
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AppConfigService, ApproveConfirmComponent, Config, ConfigMvc, LoadingComponent, PublishService, ServiceResult, SharedComponent, SharedModule, TaskResult };
//# sourceMappingURL=shared.js.map
